import { render, staticRenderFns } from "./SuccessMessageWrapper.vue?vue&type=template&id=522fcceb"
import script from "./SuccessMessageWrapper.vue?vue&type=script&lang=js"
export * from "./SuccessMessageWrapper.vue?vue&type=script&lang=js"
import style0 from "./SuccessMessageWrapper.vue?vue&type=style&index=0&id=522fcceb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports